import * as React from 'react';
import { applyConfig, Config, ConfigContext } from './context';

export const withConfig = (Component: React.FC, config: Config): React.FC => {
	return () => (
		<ConfigContext.Provider value={applyConfig(config)}>
			<Component />
		</ConfigContext.Provider>
	);
};
